import React, { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import TagGroupPills from 'src/listing/components/TagGroupPills';
import type { FullBoatSearchDetail } from 'src/common/types/api/v4/boats/search';
import { TAG_GROUP_IDS } from 'src/common/types/common/TagGroups';
import ContentGroup from 'src/common/components/ContentGroup';
import Divider from 'src/common/components/dockyard/Divider';

export type BoatExperienceTagsProps = {
  tagGroups: FullBoatSearchDetail['tag_groups'];
};

const BoatExperienceTags: FC<BoatExperienceTagsProps> = ({ tagGroups }) => {
  const [t] = useTranslation('listing-page');
  const experienceTagGroup = useMemo(() => tagGroups?.find((tagGroup) => (
    tagGroup.group_id === TAG_GROUP_IDS.Experiences
  )), [tagGroups]);

  if (!experienceTagGroup?.tags) { return null; }
  return (
    <ContentGroup gapSize="spacing-07" paddingTop="spacing-07" paddingBottom="spacing-07">
      <Typography type="h2" size="body-xl" weight="semibold">
        {t('experience-tags--title')}
      </Typography>
      {experienceTagGroup && (
        <TagGroupPills tagGroup={experienceTagGroup} withGroupTitle={false} />
      )}
      <Divider color="neutral-100" />
    </ContentGroup>
  );
};

export default BoatExperienceTags;
